module.exports = __webpack_public_path__ + "img/link-code.ce23f78b.png";